/**
 * Suspense fallback for lazy routes (dark canvas + coral spinner).
 * Keep tiny + dependency-free — it lives in the user-facing main chunk.
 */
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { colors } from '../../theme/theme';

export default function RouteFallback() {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        width: '100%',
        background: colors.background.default,
      }}
    >
      <CircularProgress
        size={36}
        thickness={4}
        sx={{ color: colors.primary.main }}
      />
    </Box>
  );
}
